import io from 'socket.io-client'
import * as types from '../mutation-types'
import * as orderTypes from '../orderModule/mutation-types'
import * as managerTypes from '../managerModule/mutation-types'
import * as userTypes from '../userModule/mutation-types'
import * as storeTempStateType from '../itemstateModule/mutation-types'
import * as storeStationType from '../workstationModule/mutation-types'
import firebase from 'firebase/app'
import 'firebase/auth'

// In local mode follow the browser's hostname so accessing the dev server
// from a non-localhost address (e.g. Tailscale IP, LAN) still hits the
// docker-exposed ws server on the same host.
const wsUrl = process.env.NODE_ENV === 'local'
  ? `ws://${window.location.hostname}:8887`
  : process.env.VUE_APP_URLS_WEBSOCKET
const socket = io(wsUrl) // 連線至伺服器

async function subscribeSocket (store) {
  if (store.getters.storeId && store.state.userModule.uid) {
    socket.emit('subscribe', {
      token: await firebase.auth().currentUser.getIdToken(/* forceRefresh */ true),
      storeId: store.state.store.id
    })
  }
}

export default store => {
  store.subscribe(async mutation => {
    switch (mutation.type) {
      case types.SET_STORE:
      case 'userModule/' + userTypes.SET_USER_INFO:
        subscribeSocket(store)
        break
      case 'userModule/' + userTypes.CLEAR_USER_INFO:
        socket.emit('unsubscribe')
        store.commit('orderModule/' + orderTypes.CLEAN_STATE)
        break
      default:
    }
  })

  socket.on('connect', () => {
    console.log('connect')
    store.commit(types.SET_SOCKET_ID, socket.id)
    subscribeSocket(store)
  })
  socket.on('updateOrder', order => {
    if (!order.deliveredAt && !store.state.orderModule.channels.secondary.orderList.find(o => o.id === order.id)) {
      store.commit('orderModule/' + orderTypes.SET_NEW_ORDER, order)
    }
    store.commit('orderModule/' + orderTypes.UPDATE_ORDER_FROM_SERVER, { order, ring: store.state.settings.newOrderRing })
  })
  socket.on('updateStoreTempState', tempState => {
    store.commit('itemstateModule/' + storeTempStateType.SET_ITEM_GATHER, tempState)
  })
  socket.on('updateStationList', stationList => {
    store.commit('workstationModule/' + storeStationType.SET_WORKSTATION_LIST, stationList)
  })
  socket.on('updateStoreClients', clients => {
    store.commit('managerModule/' + managerTypes.SET_STORE_CONNECTION_CLIENTS, clients)
  })
  socket.on('notification', data => {
    store.commit(types.SET_NOTIFICATION, data)
  })
  socket.on('errorMessage', message => { console.error('websocket server error: ' + message) })
  socket.on('pong', ms => { store.commit(types.SET_CONNECTION_LOG, { ms, socketId: socket.id }) })
  socket.on('disconnect', reason => {
    console.log('disconnect', reason)
    store.commit(types.SET_SOCKET_ID, null)
  })
}
